import React from 'react'
import './IconStyles.css';
import {MdOutlineTimer} from "react-icons/md";

export const InboundFollowupIcon = (props) => (
  <div style={{minWidth: "1.75em"}}>
    <MdOutlineTimer size={props.size ? props.size : "1.25em"}/>
  </div>
)